// extracted by mini-css-extract-plugin
export var header = "header-module--header--Zms1V";
export var menuBtn = "header-module--menuBtn--w8l5H";
export var mobileMenuOpen = "header-module--mobileMenuOpen--LkTs7";
export var mobileNavClose = "header-module--mobileNavClose--cANF7";
export var navMenu = "header-module--navMenu--z6FhI";
export var navMenuMobile = "header-module--navMenuMobile--3xL8O";
export var regionSwitch = "header-module--regionSwitch--gbkjL";